/**
 * A refused sign-in comes back with the error in the URL fragment or query.
 * The legacy boot (loadSessionFromUrl) reads it into a lexical variable and
 * scrubs the URL — unreachable from React. This module READS the same URL
 * before the legacy scripts load (module evaluation happens first) and never
 * touches it, so the legacy session pickup, pending-auth resume and URL
 * scrubbing behave exactly as before. The legacy copy's only consumer was
 * screenLogin, which React now owns.
 */
function readAuthErrorFromUrl(): string | null {
  const hash = (location.hash || '').replace(/^#/, '');
  const hashParams = new URLSearchParams(hash);
  const searchParams = new URLSearchParams(location.search || '');
  const error =
    hashParams.get('error_description') || hashParams.get('error') ||
    searchParams.get('error_description') || searchParams.get('error');
  if (!error) return null;
  return decodeURIComponent(String(error).replace(/\+/g, ' '));
}

let pendingError: string | null = readAuthErrorFromUrl();

/** The redirect error, shown once (the legacy screen nulled it after display). */
export function takeAuthRedirectError(): string | null {
  const error = pendingError;
  pendingError = null;
  return error;
}
